import { stringify } from 'query-string';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { fetchInfinite } from '@dashboard/services/request';

// react-query
async function getCoupons(sellerId, query, token) {
  return fetchInfinite(`/sellers/${sellerId}/coupons?${stringify(query)}`, token);
}

export function useCouponQueries() {
  const { token } = useAuth();

  return {
    getCoupons: (sellerId, query) => getCoupons(sellerId, query, token),
  };
}
